import { FormGroup } from "@angular/forms";
import { NgbDate, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

export class DateUtil {

    public static getDate(formControlName: String, formName: FormGroup) {
        let startDate = (formName.get(formControlName + "").value) as NgbDate;
        return startDate && startDate.year ? new Date(startDate.year, startDate.month - 1, startDate.day) : null;
    }
    static format(date: NgbDateStruct | null): string {
        const DELIMITER = '/';
        return date ? date.day + DELIMITER + date.month + DELIMITER + date.year : '';
    }
    static fromModel(date: Date): NgbDateStruct {
        return date ? {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        } : null;
    }

    static toModel(date: NgbDateStruct): Date {
        return date ? new Date(date.year, date.month - 1, date.day) : null;
    }

    static compareNgbDateStruct(date1: NgbDate ,date2: NgbDate ){
        return date1.after(date2)
    }

    static getDateFirstDayWeek(d) {
        d = new Date(d);
        let day = d.getDay();
        let diff = d.getDate() - day + (day == 0 ? -6:1);
        return new Date(d.setDate(diff));
    }

    static getDateFirstDayMonth(date: Date): Date {
        return new Date(date.getFullYear(), date.getMonth(), 1);
    }
    static getLastDayOfMonth(date?:Date): Date {
        date = date || new Date();
        let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        lastDayOfMonth.setHours(23);
        lastDayOfMonth.setMinutes(59);
        lastDayOfMonth.setSeconds(59);
        return lastDayOfMonth;
    }
    static getFirstDayOfMonth(date?: Date): Date {
        date = date || new Date();
        let firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        firstDayOfMonth.setHours(0);
        firstDayOfMonth.setMinutes(0);
        firstDayOfMonth.setSeconds(0);
        return firstDayOfMonth;
    }

    static addDays(date: Date, days: number): Date {
        date.setDate(date.getDate() +  parseInt(days+""));
        return date;
    }

static isDateBeforeToday(date) {
    return new Date(date) < new Date(new Date());
}
}
